import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles(({ palette, spacing }) => ({
  action_button: {
    backgroundColor: palette.primary.light,
    borderRadius: "50%",
    color: palette.primary.main,
    height: spacing(5),
    width: spacing(5),
  },
  author_icon: {
    color: palette.primary.main,
    marginRight: spacing(1),
  },
  author_link: { textDecoration: "underline" },
  copyright: {
    fontSize: 10,
  },
  description_text: {
    lineHeight: "16px",
  },
  edit_button: {
    color: "#ffffff !important",
    marginRight: spacing(1.5),
  },
  smmplanner_icon: { color: "white", height: 12, width: 12 },
  smmplanner_icon_wrapper: {
    alignItems: "center",
    backgroundColor: "#10202F",
    border: "1px solid #E0E2E6",
    borderRadius: "50%",
    display: "flex",
    height: spacing(3),
    justifyContent: "center",
    marginRight: spacing(1),
    width: spacing(3),
  },
  tags_wrapper: {
    display: "flex",
    flexWrap: "wrap",
    gridRowGap: spacing(1),
  },
  wrapper: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
  },
}));
